export default "__VITE_ASSET__DTEtZVwZ__"